import { SelectWithLabel } from 'components/Form'
import * as React from 'react'
import { companyResources } from 'api'

import './styles.scss'
import ModalDelete from 'components/ModalDelete'
import { getStaticImage } from 'utils/statics'
import { lang } from 'utils/helpers'

const ResourcesList = (props) => {
  const { resources, getResources, brands, delegations, editModal } = props
  const [typeOptions, setTypeOptions] = React.useState([])
  const orderOptions = [{ value: 'asc', label: 'Alfabético A-Z' }, { value: 'desc', label: 'Alfabético Z-A' }]
  const [state, setState] = React.useState({ type: null, order: null, name: null })
  const [resource, setResource] = React.useState(null)//({mimeType: 'image', mimeSubtype: 'png', size: 2000, name:'Kittie'})
  const [resourcesList, setResourcesList] = React.useState(resources)
  const [isOpenModalDelete, setIsOpenModalDelete] = React.useState(false)
  const [removing, setRemoving] = React.useState(false)

  const onChange = (value, name) => {
    setState({ ...state, [name]: value })
  }

  React.useEffect(()=> {
    setResourcesList(resources)
    search(state)
    setOptions(resources)
    setResource(null)
  }, [resources, state])

  const setOptions = (values) => {
    let _options = [{ value: 'all', label: lang('dashboard_all') }]
    values.forEach(it => {
      if (it.mimeSubtype)
        !_options.some(s => s.value === it.mimeSubtype) && _options.push({ value: it.mimeSubtype, label: it.mimeSubtype })
    })
    setTypeOptions(_options)
  }

  // React.useEffect(()=> {
  //   search(state)
  // }, [state])

  const getById = (it) => {
    if (it._id) {
      companyResources.getById(it._id).then(result => {
        setResource(result.data)
      }).catch(error => {
        console.error(error)
      })
    }
  }

  const search = (values) => {
    let _resources = resources || []
    if (_resources.length > 0) {
      if (values.name)
        _resources = _resources.filter(it => it.name.includes(values.name))
      if (values.type && values.type.value !== 'all')
        _resources = _resources.filter(it => it.mimeSubtype === values.type.value)
      if (values.order && values.order.value)
        _resources = _resources.sort((a, b) => values.order.value === 'asc' ? a.name.localeCompare(b.name) : a.name.localeCompare(b.name)*-1 )
      setResourcesList(_resources)
    }
  }

  const deleteResource = (values) => {
    setRemoving(true)
    companyResources.remove(values._id).then(result => {
      getResources(brands, delegations)
      setIsOpenModalDelete(false)
      //setResourceToRemove({})
      setRemoving(false)
      setResource(null)
    }).catch(error => {
      setIsOpenModalDelete(false)
      //setResourceToRemove({})
      setRemoving(false)
      setResource(null)
      console.error(error)
    })
  }

  const showPreview = ({ _id, mimeType, mimeSubtype, urlLong }) => {
    const preview = <img src='img/icons/icon-file-thumb-small.svg' alt='file'/>

    switch (mimeType) {
      case 'image':
        return <img className='animated fadeIn' src={urlLong} alt='preview'/>

      case 'video':
        return <video className='animated fadeIn' key={_id} src={urlLong} controls />

      case 'application':
        return mimeSubtype === 'pdf' ? <object className='animated fadeIn' data={urlLong}><span>Error al cargar</span></object>
          : preview

      default:
        return preview
    }
  }

  const showFullScreen = (resource) => {
    window.open(resource.urlLong, "_blank", "noreferrer")
  }

  return (
    <div className='resources-list'>
      <div className='list'>
        <div className='seccion-1'>
          <div className='input-search-wrapper'>
            <i className='fa fa-search'/>
            <input type='text' name='name' placeholder={lang('dashboard_search')} onChange={({ target })=>setState({ ...state, name: target.value })}></input>
          </div>
          <div className='selectors-ordering'>
            <SelectWithLabel
              name='type'
              options={typeOptions}
              value={state.type}
              onChange={(value)=>onChange(value, 'type')}
              classNameWrapper='selectors-type'
              placeholder={lang('dashboard_type')}
            />
            <SelectWithLabel
              name='order'
              options={orderOptions}
              value={state.order}
              onChange={(value)=>onChange(value, 'order')}
              classNameWrapper='selectors-order'
              placeholder={lang('dashboard_order-by')}
            />
          </div>
        </div>
        <div className='seccion-2'>
          {
            resourcesList.map(it => (
              <div key={it._id} className='file-detail'>
                <div className='filename'>
                  <img src='img/icons/icon-file-thumb-small.svg' alt='file'/>
                  <span onClick={()=>getById(it)}>{it.name}</span>
                </div>
                <span className='size'>{it.size > 0 ? `${Math.round(it.size / 1024)}kb` : 0}</span>
              </div>
            ))
          }
        </div>
      </div>
      {resource && <div className='detail animated fadeIn'>
        {/* {()=>showPreview(resource)} */}
        {showPreview(resource)}
        <div className='filename'><span>{resource.name}</span></div>
        <span className='size'>{resource.mimeSubtype} - {resource.size > 0 ? `${Math.round(resource.size / 1024)}kb` : 0}</span>
        <div className='actions'>
          <img className='delete' src={getStaticImage('/icons/orange-brand/icon-edit-2.svg')} alt='Edit' onClick={()=>editModal(resource)}/>
          <img className='delete' src={getStaticImage('/icons/orange-brand/icon-delete-2.svg')} alt='Delete' onClick={()=>setIsOpenModalDelete(true)}/>
          <img className='delete' src={getStaticImage('/icons/orange-brand/icon-fullscreen.svg')} alt='FullScreen' onClick={()=>showFullScreen(resource)}/>
        </div>
      </div>}

      <ModalDelete
        isOpen={isOpenModalDelete}
        toggle={()=>setIsOpenModalDelete(!isOpenModalDelete)}
        header={lang('dashboard_delete-resource')}
        text1={lang('resources_remove_resource_title')}
        text2={lang('dashboard_action-cannot-reversed')}
        event={()=>deleteResource(resource)}
        isSubmitting={removing}
      />
    </div>
  )
}

export default ResourcesList